import { render, staticRenderFns } from "./CardPropertiesChips.vue?vue&type=template&id=003d0eab"
import script from "./CardPropertiesChips.vue?vue&type=script&lang=js"
export * from "./CardPropertiesChips.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports